import React, { forwardRef, useImperativeHandle, useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import InputGroup from 'react-bootstrap/InputGroup';
import axios from '../../../interceptor/axios-config';
import config from '../../../config';
import { useGrade } from '../../../context/GradeContext';
import { useARData } from '../../../context/AttendanceRecordContext';
import { useStudentsData } from '../../../context/StudentsContext';
import AttendanceTable from '../Student/AttendanceTable';
import Swal from 'sweetalert2';
import { ClipLoader } from 'react-spinners';
import '../../../css/spinner.css';

const DailyAttendanceModal = forwardRef((props, ref) => {

    const [attendanceArray, setAttendanceArray] = useState([]);

    //For Spinner 
    const [loading, setLoading] = useState(false);

    const [modalBox, setModalBox] = useState(false);
    const [formData, setFormData] = useState({});

    // Attendance records provider 
    const { arData } = useARData();

    //grades
    const { grade } = useGrade();

    //get details of all the students
    const { studentsData } = useStudentsData();

    // get selected grade 
    const [selectedGrade, setSelectedGrade] = useState(null);

    //filtered grade for adding attendance record
    const [gradeFiltered, setGradeFiltered] = useState(null);

    //function to get selected grade
    const handleGradeSelection = (e) => {
        setSelectedGrade(e.target.value);
    };

    console.log(gradeFiltered);

    useEffect(()=>{
        if(selectedGrade && studentsData){
            const filterByGrade = studentsData.filter(grade => grade.class_admitted === `${selectedGrade}`);
            setGradeFiltered(filterByGrade);
        }else{
            setGradeFiltered(null);
        }
    },[selectedGrade])


    // Current date 
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(currentDate.getDate()).padStart(2, '0');

    const formattedDate = `${day}-${month}-${year}`;

    useImperativeHandle(ref, () => ({
        openModal() {
            setModalBox(true);            
        },  
    }));

    // function to close the attendance modal clearing all data 
    const closeARModal = () =>{
        setGradeFiltered(null);
        setModalBox(false); 
    }

    console.log(attendanceArray);

  const saveAttendance = async () => {
    setLoading(true);  // Start spinner
    try {
        for(var i = 0; i < attendanceArray.length; i++){
            const response = await axios.post(`${config.apiBaseUrl}/students/addAttendance.php`, attendanceArray[i]);
            if (response.status === 200) {
              // Continue to next iteration
              continue;
            } else {
              // Handle non-200 responses if needed
              throw new Error('Failed to submit attendance');
            }
          }
    
          // Show success message after all submissions are complete
          Swal.fire({
            icon: 'success',
            title: 'Attendance registered successfully',
            text: `Date: ${new Date().toISOString().split('T')[0]}, attendance for Class added successfully!`,
          });
    } catch (error) {
        console.error('Error uploading data:', error);
      } finally {
        setLoading(false);  // Stop spinner
        console.log('Submission completed');
      }
};

  return (
    <>
        {loading && (
                <div className="spinner-container">
                <ClipLoader size={50} color={"#123abc"} loading={loading} />
                </div>
            )}
        <Modal  onHide={setModalBox} size='xl' show={modalBox} centered>
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">Daily Attendance Form : Date-{formattedDate}</h5>
                    <button type="button" className="btn-close"  onClick={closeARModal}></button>
                </div>
                <div className="modal-body">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-xl-12 col-lg-4 d-block">
                                <div className="mb-3">
                                    <InputGroup className="mb-3">                                
                                        <InputGroup.Text id="basic-addon1">Select Class</InputGroup.Text>                                            
                                        <select name="grade" value={formData.subject_for_class} onChange={handleGradeSelection} className="form-control" id="exampleFormControlInput4" required>
                                            {/* <option value="">--Select Class--</option> */}
                                            {grade.map((item) => <option value={item.class_options}>{item.class_label}</option>)}
                                        </select>
                                        <span className='p-2'></span>
                                        <InputGroup.Text id="basic-addon1" className='bg-success text-white'>P-> Present</InputGroup.Text>
                                        <span className='p-2'></span>
                                        <InputGroup.Text id="basic-addon1" className='bg-danger text-white'>A-> Absent</InputGroup.Text>
                                    </InputGroup>
                                </div>
                                {gradeFiltered !== null
                                    ?(
                                        <AttendanceTable students={gradeFiltered} setAttendanceArray={setAttendanceArray}/>
                                    )
                                    :'No student found'
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-success light" onClick={saveAttendance}>Save</button>
                    <button type="button" className="btn btn-danger light" onClick={closeARModal}>Close</button>
                </div>
            </div>                
        </Modal>
        
    </>
  )
})


export default DailyAttendanceModal
